import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAllPermissionGroupsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllPermissionGroupsQuery = { __typename?: 'Query', allPermissionGroups: Array<{ __typename: 'PermissionGroup', id: string, name: string, company?: string | null, createdBy: { __typename?: 'User', id: string, name: string }, modifiedBy: { __typename?: 'User', id: string, name: string }, markets: Array<{ __typename?: 'Market', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string }>, users: Array<{ __typename?: 'User', id: string, name: string }> }> };

export type CreatePermissionGroupMutationVariables = Types.Exact<{
  input: Types.CreatePermissionGroupInput;
}>;


export type CreatePermissionGroupMutation = { __typename?: 'Mutation', createPermissionGroup: { __typename?: 'PermissionGroupPayload', permissionGroup: { __typename?: 'PermissionGroup', id: string } } };

export type UpdatePermissionGroupMutationVariables = Types.Exact<{
  input: Types.UpdatePermissionGroupInput;
}>;


export type UpdatePermissionGroupMutation = { __typename?: 'Mutation', updatePermissionGroup: { __typename?: 'PermissionGroupPayload', permissionGroup: { __typename?: 'PermissionGroup', id: string } } };

export type DeletePermissionGroupMutationVariables = Types.Exact<{
  input: Types.DeletePermissionGroupInput;
}>;


export type DeletePermissionGroupMutation = { __typename?: 'Mutation', deletePermissionGroup: { __typename?: 'DeletePermissionGroupPayload', permissionGroup?: { __typename?: 'PermissionGroup', id: string } | null } };


export const GetAllPermissionGroupsDocument = gql`
    query GetAllPermissionGroups {
  allPermissionGroups {
    id
    createdBy {
      id
      name
    }
    modifiedBy {
      id
      name
    }
    name
    company
    markets {
      id
      name
    }
    keywords {
      id
      name
    }
    users {
      id
      name
    }
    __typename
  }
}
    `;

/**
 * __useGetAllPermissionGroupsQuery__
 *
 * To run a query within a React component, call `useGetAllPermissionGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPermissionGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPermissionGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPermissionGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPermissionGroupsQuery, GetAllPermissionGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPermissionGroupsQuery, GetAllPermissionGroupsQueryVariables>(GetAllPermissionGroupsDocument, options);
      }
export function useGetAllPermissionGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPermissionGroupsQuery, GetAllPermissionGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPermissionGroupsQuery, GetAllPermissionGroupsQueryVariables>(GetAllPermissionGroupsDocument, options);
        }
export type GetAllPermissionGroupsQueryHookResult = ReturnType<typeof useGetAllPermissionGroupsQuery>;
export type GetAllPermissionGroupsLazyQueryHookResult = ReturnType<typeof useGetAllPermissionGroupsLazyQuery>;
export type GetAllPermissionGroupsQueryResult = Apollo.QueryResult<GetAllPermissionGroupsQuery, GetAllPermissionGroupsQueryVariables>;
export const CreatePermissionGroupDocument = gql`
    mutation CreatePermissionGroup($input: CreatePermissionGroupInput!) {
  createPermissionGroup(input: $input) {
    permissionGroup {
      id
    }
  }
}
    `;
export type CreatePermissionGroupMutationFn = Apollo.MutationFunction<CreatePermissionGroupMutation, CreatePermissionGroupMutationVariables>;

/**
 * __useCreatePermissionGroupMutation__
 *
 * To run a mutation, you first call `useCreatePermissionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePermissionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPermissionGroupMutation, { data, loading, error }] = useCreatePermissionGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePermissionGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreatePermissionGroupMutation, CreatePermissionGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePermissionGroupMutation, CreatePermissionGroupMutationVariables>(CreatePermissionGroupDocument, options);
      }
export type CreatePermissionGroupMutationHookResult = ReturnType<typeof useCreatePermissionGroupMutation>;
export type CreatePermissionGroupMutationResult = Apollo.MutationResult<CreatePermissionGroupMutation>;
export type CreatePermissionGroupMutationOptions = Apollo.BaseMutationOptions<CreatePermissionGroupMutation, CreatePermissionGroupMutationVariables>;
export const UpdatePermissionGroupDocument = gql`
    mutation UpdatePermissionGroup($input: UpdatePermissionGroupInput!) {
  updatePermissionGroup(input: $input) {
    permissionGroup {
      id
    }
  }
}
    `;
export type UpdatePermissionGroupMutationFn = Apollo.MutationFunction<UpdatePermissionGroupMutation, UpdatePermissionGroupMutationVariables>;

/**
 * __useUpdatePermissionGroupMutation__
 *
 * To run a mutation, you first call `useUpdatePermissionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePermissionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePermissionGroupMutation, { data, loading, error }] = useUpdatePermissionGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePermissionGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePermissionGroupMutation, UpdatePermissionGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePermissionGroupMutation, UpdatePermissionGroupMutationVariables>(UpdatePermissionGroupDocument, options);
      }
export type UpdatePermissionGroupMutationHookResult = ReturnType<typeof useUpdatePermissionGroupMutation>;
export type UpdatePermissionGroupMutationResult = Apollo.MutationResult<UpdatePermissionGroupMutation>;
export type UpdatePermissionGroupMutationOptions = Apollo.BaseMutationOptions<UpdatePermissionGroupMutation, UpdatePermissionGroupMutationVariables>;
export const DeletePermissionGroupDocument = gql`
    mutation DeletePermissionGroup($input: DeletePermissionGroupInput!) {
  deletePermissionGroup(input: $input) {
    permissionGroup {
      id
    }
  }
}
    `;
export type DeletePermissionGroupMutationFn = Apollo.MutationFunction<DeletePermissionGroupMutation, DeletePermissionGroupMutationVariables>;

/**
 * __useDeletePermissionGroupMutation__
 *
 * To run a mutation, you first call `useDeletePermissionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePermissionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePermissionGroupMutation, { data, loading, error }] = useDeletePermissionGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePermissionGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeletePermissionGroupMutation, DeletePermissionGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePermissionGroupMutation, DeletePermissionGroupMutationVariables>(DeletePermissionGroupDocument, options);
      }
export type DeletePermissionGroupMutationHookResult = ReturnType<typeof useDeletePermissionGroupMutation>;
export type DeletePermissionGroupMutationResult = Apollo.MutationResult<DeletePermissionGroupMutation>;
export type DeletePermissionGroupMutationOptions = Apollo.BaseMutationOptions<DeletePermissionGroupMutation, DeletePermissionGroupMutationVariables>;